import { logStatus } from "../../utils";
export class Transmitter {
    constructor(gluePromise, asyncConstructors, loggerClient) {
        this.asyncConstructors = asyncConstructors;
        this.loggerClient = loggerClient;
        this.subscriptions = {};
        const pw = asyncConstructors.addConstructor();
        gluePromise.then((g) => {
            this.glue = g;
            asyncConstructors.finishConstructor(pw);
        });
    }
    logStatus(method, type, data) {
        logStatus(this.loggerClient, this.glue, {
            api: "Router.transmit",
            method, type, data
        });
    }
    addListener(channel, eventHandler) {
        this.logStatus("addListener", "start", { channel });
        let iocdSubscription = null;
        const addListenerCore = async () => {
            await this.asyncConstructors.ready();
            iocdSubscription = await this.glue.bus.subscribe(channel, (data, topic, source) => {
                const { peerId = "Unknown peer" } = source;
                const response = {
                    data: data._data,
                    originatedHere: () => source.peerId === this.glue.interop.instance.peerId,
                    options: { suppressWarnings: false },
                    header: {
                        type: "transmit",
                        channel,
                        incomingTransportInfo: { lastClient: peerId, origin: peerId, transportID: "FinsembleTransport" },
                        lastClient: peerId,
                        origin: peerId,
                        originMetadata: {
                            routerConnectionId: "",
                            transportInfo: {
                                transportID: "FinsembleTransport"
                            },
                            windowName: "",
                            appId: "",
                            webContentsName: ""
                        }
                    }
                };
                eventHandler(null, response);
            });
            this.subscriptions[channel] = (this.subscriptions[channel] ?? []).concat({ iocdSubscription, eventHandler });
        };
        addListenerCore();
        this.logStatus("addListener", "return");
        return () => {
            if (!iocdSubscription) {
                return;
            }
            this.subscriptions[channel] = (this.subscriptions.channel ?? []).filter((sub) => sub.iocdSubscription !== iocdSubscription);
            if (!this.subscriptions[channel].length) {
                delete this.subscriptions[channel];
            }
            iocdSubscription.unsubscribe();
        };
    }
    removeListener(channel, eventHandler) {
        this.logStatus("removeListener", "start", { channel });
        const unregister = async () => {
            await this.asyncConstructors.ready();
            const subs = this.subscriptions[channel] ?? [];
            subs.forEach((subscription) => {
                if (!eventHandler || subscription.eventHandler === eventHandler) {
                    subscription.iocdSubscription.unsubscribe();
                    this.subscriptions[channel] = this.subscriptions[channel].filter((sub) => sub !== subscription);
                }
            });
            if (!this.subscriptions[channel]?.length) {
                delete this.subscriptions[channel];
            }
        };
        unregister();
        this.logStatus("removeListener", "return");
    }
    async transmit(toChannel, data, options) {
        this.logStatus("transmit", "start", { toChannel });
        await this.asyncConstructors.ready();
        try {
            await this.glue.bus.publish(toChannel, { _data: data });
        }
        catch (e) {
            console.error("Router transmit() error calling invoke", e);
        }
        this.logStatus("transmit", "return");
    }
}
